import { jewlr_t } from "helpers/application"

const whyData = () => [
  {
    title: `Online ${jewlr_t("terms.personalization")} is now incredibly easy`,
    why: [
      {
        question: `Anyone can create ${jewlr_t("terms.customize")}d ${jewlr_t(
          "terms.jewelry"
        )} with Jewlr, because our website is the best of its kind – even if we do say so ourselves. We’ve taken 3D technology from the movie industry to show you exactly what your design is going to look like even before it’s made. You can choose any font and see it instantly engraved on a ring, for example. Just click and select your stones. Choose the metal and see how it looks. Simply follow the step-by-step instructions and see the ${jewlr_t(
          "terms.jewelry"
        )} take shape. Even if you never end up buying it, it’s still great fun to do.`,
      },
    ],
  },
  {
    title: "Outstanding handcrafted quality",
    why: [
      {
        question:
          "Buying online doesn’t mean buying cheap. All our items are handmade by professional craftsmen in the USA and Canada. You decide on the materials. Splurge on gold and diamonds or create an affordable silver ring with our collection of colorful simulated gemstones or our Brilliance Cubic Zirconia. Depending on your choice of metals, stones, and engravings, the same style can cost a few hundred or a few thousand dollars.",
      },
    ],
  },
  {
    title: `Fast creation, fast free ${jewlr_t(
      "terms.shipping"
    )} and gift-ready packaging`,
    why: [
      {
        question:
          `Once you’ve finished your design, our ${jewlr_t(
            "terms.jeweler"
          )}s will get to work. They will ship in <a style='color: #2468b2' href='${
            sl.basename
          }/info/shipping_information'> as little as 3 days</a> and we offer free fast ${jewlr_t(
            "terms.shipping"
          )} to US, Canada, United Kingdom and Australia. Optional overnight ${jewlr_t(
            "terms.shipping"
          )} is available at a low cost.<br/><br/>` +
          `When your order arrives it’s <a style='color: #2468b2' href='${sl.basename}/info/packaging'>ready for giving</a>. It will include an elegant box with your your packing slip and Certificate of Authenticity.`,
      },
    ],
  },
  {
    title: "It’s cheaper to buy directly from us",
    why: [
      {
        question:
          "How can we sell at such a low price? Because we only sell online and don’t have the overheads of expensive retail stores. We’ve also cut out the middle man and pass on the savings to you. What’s more, we are a bulk buyer of raw materials so get a lower price than a local artisan, while still producing handcrafted designs.<br/><br/>" +
          `All this means is that you can buy custom made items for less than the price of mass-market ${jewlr_t(
            "terms.jewelry"
          )} produced in Asia. Now that’s win-win.`,
      },
    ],
  },
  {
    title: "Security, service and satisfaction guarantees",
    why: [
      {
        question:
          `${jewlr_t(
            "terms.Jewelry"
          )} and customer service are our twin passions. We take pride in every piece we produce and want you and your loved ones to be as happy with it as we are.<br/><br/>` +
          `Every item is hand made and inspected multiple times during the manufacturing process. We also provide a <a style='color: #2468b2' href='${sl.basename}/info/warranty-information'>1 year warranty on all items</a> and you can <a style='color: #2468b2' href='${sl.basename}/info/returns'>return any item</a> – even engraved ones – within 99-Days for a full refund of the purchase price. We’ll even provide one free resizing of any ring (North America only).<br/><br/>` +
          `Service is our pleasure. You can contact us by phone, email or live chat at any time. We are one of the biggest online ${jewlr_t(
            "terms.jewelry"
          )} retailers, ${jewlr_t(
            "terms.shipping"
          )} tens of thousands of items every year. Let our customers speak for themselves: see our 5 star reviews at <a style='color: #2468b2' href='https://www.resellerratings.com/store/Jewlr_com'>ResellerRatings</a>, how we were voted <a style='color: #2468b2' href='${
            sl.basename
          }/info/press/jewlr_named_innovative_retailer_in_2013'>Most Innovative Retailer in Canada</a> and how our customers regularly tell us how much they <a style='color: #2468b2' href='${
            sl.basename
          }/reviews'>appreciate what we’ve done</a>. Not to mention countless features in newspapers and magazines, including Oprah and Parenting Magazine.<br/><br/>` +
          `Security is assured when you order with us. We are members of the BBB, ${jewlr_t(
            "terms.Jewelry"
          )} Industry Associations and our online security is regularly audited by industry watchdogs Verisign, Trustwave and Authorize.net. We never store your credit card number and offer full guarantees for every order.`,
      },
    ],
  },
]

export default whyData
